module.exports = __webpack_public_path__ + "img/4_87.1a0b8d02.png";